import { createSearchParams, useNavigate, useSearchParams } from "react-router-dom";

export default function useNavigateParams() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (pathname: string) => {
    const path = {
      pathname,
      search: createSearchParams(searchParams).toString(),
    };
    navigate(path);
  };
}
